import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import HeroCarousel from '../components/HeroCarousel';
import GroundsGrid from '../components/GroundsGrid';
import Services from '../components/Services';
import HowItWorks from '../components/HowItWorks';
import CTABanner from '../components/CTABanner';
import BookingModal from '../components/BookingModal';
import Footer from '../components/Footer';
import About from '../components/About';

const HomePage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Auto-open modal after 3 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      openModal();
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Navbar />
      <HeroCarousel openBookingModal={openModal} />
      <GroundsGrid openBookingModal={openModal} />
      <Services />
      
      <HowItWorks />
      <CTABanner />
      <About/>
      <Footer />
      <BookingModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default HomePage;